export const PhotoUploader = ({ onPhotosAdded, multiple = true, buttonText = "Add Photos", showAsButton = false, buttonClass = "btn btn-sm btn-outline-primary" }) => {
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        files.forEach(file => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const newPhoto = {
                    name: file.name,
                    url: event.target.result,
                    uploadedAt: new Date().toISOString(),
                    file: file,
                    isNew: true
                };
                onPhotosAdded(newPhoto);
            };
            reader.readAsDataURL(file);
        });
        e.target.value = '';
    };

    if (showAsButton) {
        const inputId = `photo-upload-${Date.now()}`;
        return (
            <>
                <button 
                    className={buttonClass}
                    onClick={() => document.getElementById(inputId).click()}
                    title={buttonText}
                >
                    <i className="fa fa-camera"></i>
                </button>
                <input 
                    id={inputId}
                    type="file" 
                    accept="image/*" 
                    multiple={multiple}
                    style={{display: 'none'}}
                    onChange={handleFileChange}
                />
            </>
        );
    }

    return (
        <input 
            type="file" 
            accept="image/*" 
            multiple={multiple}
            className="form-control"
            onChange={handleFileChange}
        />
    );
};